import { ff } from '@atlassian/jira-feature-flagging';

// <rkarki>
export const TABULAR_GRID_FIELDS = 'jsw.uif.tmp.card.tabular.grid';
export const isTabularGridFieldsEnabled = () => ff(TABULAR_GRID_FIELDS, false);
// </rkarki>

// <bento>
// </bento>
